import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseResult } from '@app/auth/model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserCreditDebitService {
  private route: string = "financial";
  private controller: string = "userCreditDebit";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getAll(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/get`);
  }

  getById(id: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/${id}`);
  }

  getByIndication(indicationId: Number): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/GetByIndication/${indicationId}`);
  }

  getByUserGuid(pUserGuid: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/GetByUserGuid/${pUserGuid}`);
  }

  summaryByUserGuid(pUserGuid: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/SummaryByUserGuid/${pUserGuid}`);
  }

  summaryForAdmin(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/SummaryForAdmin`);
  }

  patch(id: number, model: any): any {
    return this.http.patch<ResponseResult>(`${this.endpointPrefix}/${id}`, JSON.stringify(model), {
      headers: {
        'Content-Type': 'application/json-patch+json'
      }
    });
  }

  remove(id: any): Observable<any> {
    return this.http.delete<ResponseResult>(`${this.endpointPrefix}/${id}`);
  }

  save(id: number, model: any, editing: boolean = false): any {
    if (editing) { //update
      return this.http.put<ResponseResult>(`${this.endpointPrefix}/${id}`, model);
    } else { //new
      return this.http.post<ResponseResult>(`${this.endpointPrefix}/add`, model);
    }
  }
}
